import { onCLS, onINP, onLCP } from 'web-vitals';

/**
 * Small library used to report on web vitals
 */
const reportWebVitals = () => {
	/** Cumulative Layout Shift */
	onCLS(console.log);
	/** Interaction to Next Paint */
	onINP(console.log);
	/** Largest Contentful Paint */
	onLCP(console.log);
};

export default reportWebVitals;
